<template>
    <div id="main3">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page" v-else>
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('atendimento') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('relatorios') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('atendimento') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="voltar()">
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <div class="page-container mt-2 mb-4 pb-6">
                    <div class="header">
                        <div class="botoes"></div>
                        <div class="enterprise-logo">
                            <img class="logo" :src="data.logoEmpresaUrl" alt />
                        </div>
                        <div class="enterprise-info">
                            <h2>{{ data.rsocial }}</h2>
                            <p>{{ data.endereco }}</p>
                            <p>{{ data.cidade }}</p>
                            <p>{{ data.cep }}</p>
                        </div>
                        <div class="client-logo">
                            <img class="logo" :src="data.clientlogo" alt v-if="data.clientlogo" />
                        </div>
                    </div>
                    <div class="form" v-if="data.cliente">
                        <div class="form-client">
                            <div class="separator">
                                {{ $t('dados-cliente') }}
                            </div>
                            <div class="data-block">
                                <div class="client-info">
                                    <h4 class="label">{{ $t('nome') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.nome ? data.cliente.nome : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('razao-social') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.rsocial ? data.cliente.rsocial : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cnpj-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.cnpj ? data.cliente.cnpj : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('inscricao-estadual-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.ie ? data.cliente.ie : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('regiao') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.regiao ? data.cliente.regiao : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cidade') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.cidade ? data.cliente.cidade : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('endereco-do-promotor') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.endereco ? data.cliente.endereco : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('bairro-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.bairro ? data.cliente.bairro : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cep-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.cep ? data.cliente.cep : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('telefone-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.telefone ? data.cliente.telefone : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('fax-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.fax ? data.cliente.fax : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('celular-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.celular ? data.cliente.celular : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('email') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.cliente.email ? data.cliente.email : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('colaborador') + ': ' }}</h4>
                                    <p class="answer">
                                        {{
                                            data.cliente.colaborador ? data.cliente.colaborador : ''
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="form-client">
                            <div class="separator">
                                {{ $t('dados-lps') }}
                            </div>
                            <div class="data-block">
                                <div class="client-info">
                                    <h4 class="label">{{ $t('nome') + ': ' }}</h4>
                                    <p class="answer">{{ data.lps.nome ? data.lps.nome : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('razao-social') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.lps.rsocial ? data.lps.rsocial : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cnpj-do-cliente') }}</h4>
                                    <p class="answer">{{ data.lps.cnpj ? data.lps.cnpj : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('inscricao-estadual-do-cliente') }}</h4>
                                    <p class="answer">{{ data.lps.ie ? data.lps.ie : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('regiao') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.lps.regiao ? data.lps.regiao : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cidade') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.lps.cidade ? data.lps.cidade : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('endereco-do-promotor') }}</h4>
                                    <p class="answer">
                                        {{ data.lps.endereco ? data.lps.endereco : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('bairro-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.lps.bairro ? data.lps.bairro : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('cep-do-cliente') }}</h4>
                                    <p class="answer">{{ data.lps.cep ? data.lps.cep : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('telefone-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.lps.telefone ? data.lps.telefone : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('fax-do-cliente') }}</h4>
                                    <p class="answer">{{ data.lps.fax ? data.lps.fax : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('celular-do-cliente') }}</h4>
                                    <p class="answer">
                                        {{ data.lps.celular ? data.lps.celular : '' }}
                                    </p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('email') + ': ' }}</h4>
                                    <p class="answer">{{ data.lps.email ? data.lps.email : '' }}</p>
                                </div>
                                <div class="client-info">
                                    <h4 class="label">{{ $t('colaborador') + ': ' }}</h4>
                                    <p class="answer">
                                        {{ data.lps.colaborador ? data.lps.colaborador : '' }}
                                    </p>
                                </div>
                            </div>
                            <div class="map-photo">
                                <img :src="mapimg" />
                            </div>
                        </div>

                        <div class="form-client" v-if="justificativa && justificativa.motivoJustificativa">
                            <div class="separator">
                                {{ $t('justificativa') }}
                            </div>
                            <div class="data-block-form">
                                <div class="client-info">
                                    <h4 class="label">{{ $t('motivo-justificativa') }}</h4>
                                    <h4 class="label">{{ $t('contato') }}</h4>
                                    <h4 class="label">{{ $t('descricao') }}</h4>
                                    <h4 class="label">{{ $t('data-visita') }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                </div>
                                <div class="client-info">
                                    <p class="answer">
                                        {{ this.justificativa.motivoJustificativa ? this.justificativa.motivoJustificativa : '' }}
                                    </p>
                                    <p class="answer">
                                            {{ this.justificativa.contato 
                                                ? this.justificativa.contato : '' }}
                                    </p>
                                    <p class="answer">
                                            {{ this.justificativa.descricao 
                                                ? this.justificativa.descricao : '' }}
                                    </p>
                                    <p class="answer">
                                            {{ $moment(this.justificativa.dataVisita).format('L')
                                                ? $moment(this.justificativa.dataVisita).format('L') : '' }}
                                    </p>
                                    <p class="answer">
                                            {{ $moment(this.justificativa.dataHora).format('L LT') 
                                                ? $moment(this.justificativa.dataHora).format('L LT')  : '' }}
                                    </p>
                                </div>
                                <div class="data-block-img">
                                    <div class="option">
                                        <div
                                        class="opt-img-block"
                                        v-for="(ft, i) in fotosJustificativa"
                                        :key="i"
                                        >
                                            <div>
                                                <div class="opt-teste">
                                                    <img
                                                        class="is-clickable"
                                                        :src="ft.caminho"
                                                        :alt="ft.nome"
                                                        @click="showModalFotos(this.justificativa, i)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            <br>
                                                            {{
                                                                ft.datahora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p
                                                            v-if="!isNull(ft.observacao)"
                                                            class="opt-text-observacao"
                                                        >
                                                            {{ $t('observacao') }}: {{ ft.observacao }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-client" v-if="data.horario && data.horario.length > 0">
                            <div class="separator">
                                {{ $t('horarios') }} (Total: {{ totalTime(data.horario) }} )
                            </div>
                            <div class="data-block-form">
                                <div class="client-info">
                                    <h4 class="label">{{ $t('entrada') }}</h4>
                                    <h4 class="label">{{ $t('bateria') }}</h4>
                                    <h4 class="label smaller">{{ $t('gps') }}</h4>
                                    <h4 class="label">{{ $t('saida') }}</h4>
                                    <h4 class="label">{{ $t('bateria') }}</h4>
                                    <h4 class="label smaller">{{ $t('gps') }}</h4>
                                    <h4 class="label">{{ $t('tempo_atendimento') }}</h4>
                                </div>
                                <div class="client-info" v-for="(hora, i) in data.horario" :key="i">
                                    <p class="answer">
                                        {{ hora.datahora_checkin | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        {{ hora.bateria_checkin ? hora.bateria_checkin : '' }} %
                                    </p>
                                    <p class="answer smaller">
                                        <span
                                            v-if="
                                                verifyLocationIsValid(
                                                    hora.latitude_checkin,
                                                    hora.longitude_checkin
                                                )
                                            "
                                            @click="
                                                openLocation(
                                                    hora.latitude_checkin,
                                                    hora.longitude_checkin
                                                )
                                            "
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <p class="answer">
                                        {{ hora.datahora_checkout | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        {{ hora.bateria_checkout ? hora.bateria_checkout : '' }} %
                                    </p>
                                    <p class="answer smaller">
                                        <span
                                            v-if="
                                                verifyLocationIsValid(
                                                    hora.latitude_checkout,
                                                    hora.longitude_checkout
                                                )
                                            "
                                            @click="
                                                openLocation(
                                                    hora.latitude_checkout,
                                                    hora.longitude_checkout
                                                )
                                            "
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <p class="answer">{{ hora.tempo_atendimento }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="form-client" v-if="data.fotos && data.fotos.length > 0">
                            <div class="separator icon-button">
                                {{ $t('fotos') + ' (' + numFotos + ')' }}
                                <b-button 
                                    class="icon-position" 
                                    @click="carregarFotos">
                                    <b-icon 
                                        icon="download" 
                                        font-scale="2" 
                                        v-tippy
                                        :title="$t('download-foto')"
                                    />
                                </b-button>
                            </div>
                            <div class="data-block-img">
                                <div class="option">
                                    <div
                                        class="opt-img-block"
                                        v-for="(ft, i) in data.fotos"
                                        :key="i"
                                    >
                                        <div>
                                            <div class="opt-img">
                                                <img
                                                    class="is-clickable"
                                                    :src="ft.caminho"
                                                    :alt="ft.nome"
                                                    @click="showModalFotos(data.fotos, i)"
                                                />
                                            </div>
                                            <div class="opt-legend">
                                                <div class="opt-text">
                                                    <p>
                                                        {{ ft.motivofoto }} <br />
                                                        {{
                                                            ft.datahora
                                                                | moment('DD/MM/YYYY HH:mm:ss')
                                                        }}
                                                    </p>
                                                    <p
                                                        v-if="!isNull(ft.observacao)"
                                                        class="opt-text-observacao"
                                                    >
                                                        {{ $t('observacao') }}: {{ ft.observacao }}
                                                    </p>
                                                </div>
                                                <div class="icon-location">
                                                    <b-checkbox
                                                        v-model="ft.exportaRelatorio"
                                                        @input="(event) => changeImageVisibilityInReport(event, ft, 'atendimento-foto')"
                                                        class="is-larger"
                                                        type="is-primary"
                                                    />
                                                    <span
                                                        v-if="verifyLocationIsValid(ft.lat, ft.lng)"
                                                        @click="openLocation(ft.lat, ft.lng)"
                                                    >
                                                        <b-icon
                                                            class="map-marker"
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-primary"
                                                        />
                                                    </span>
                                                    <b-icon
                                                        v-else
                                                        pack="fas"
                                                        icon="map-marker-alt"
                                                        type="is-gray"
                                                    />
                                                    <div @click="openEditFotoModal(ft, 'atendimento-foto')">
                                                        <b-icon
                                                            class="map-marker"
                                                            icon="pencil"
                                                            type="is-primary"
                                                        />
                                                    </div>
                                                    <div @click="showConfirmModal('deseja-excluir-foto-atendimento', ft, 'atendimento-foto')">
                                                        <b-icon
                                                            class="map-marker"
                                                            icon="delete"
                                                            type="is-danger"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-client" v-if="data.rupturas && data.rupturas.length > 0">
                            <div class="separator">
                                {{ $t('ruptura-troca') + rupturaComplement }}
                            </div>
                            <div class="data-block-img ruptura">
                                <div class="client-info">
                                    <h4 class="label bigger">{{ $t('produto') }}</h4>
                                    <h4 v-if="habilita_troca" class="label">{{ $t('troca') }}</h4>
                                    <h4 v-if="habilita_area_venda" class="label">{{ $t('area-venda') }}</h4>
                                    <h4 v-if="habilita_deposito" class="label">{{ $t('deposito') }}</h4>
                                    <h4 v-if="habilita_houve_ruptura" class="label">{{ $t('ruptura') + '?' }}</h4>
                                    <h4 v-if="habilita_obriga_qtde_sugerida" class="label mid-size ml-4 mr-4">{{ `${$t('quantidade-sugerida')} ${habilita_obriga_qtde_sugerida === 2 ? '*' : ''}` }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                    <h4 class="label">{{ $t('gps') }}</h4>
                                </div>
                                <div class="client-info" v-for="(pd, i) in data.rupturas" :key="i">
                                    <p class="answer bigger">{{ pd.produto ? pd.produto : "--" }}</p>
                                    <p v-if="habilita_troca" class="answer">{{ pd.qtde_item_troca ? pd.qtde_item_troca : "--" }}</p>
                                    <p v-if="habilita_area_venda" class="answer">{{ pd.gondola || pd.gondola >= 0 ? pd.gondola : "--" }}</p>
                                    <p v-if="habilita_deposito" class="answer">{{ pd.estoque || pd.estoque >= 0 ? pd.estoque : "--" }}</p>
                                    <p v-if="habilita_houve_ruptura" class="answer">
                                        {{ pd.ruptura == 1 ? $t('sim') : $t('nao') }}
                                    </p>
                                    <p v-if="habilita_obriga_qtde_sugerida" class="answer mid-size ml-4 mr-4">
                                        <v-input
                                            v-model="pd.qtdeSugerida"
                                            :required="habilita_obriga_qtde_sugerida === 2"
                                            :msg="'msg-campo-obrigatorio'"
                                            :invalid="isQtdeSugeridaInvalid(pd.qtdeSugerida)"
                                            @onBlurFunction="() => {
                                                if(pd.qtdeSugerida < 0) pd.qtdeSugerida = 0;

                                                saveQtdeSugerida(pd.id, pd.qtdeSugerida);
                                            }"
                                            :onFocus="() => saveInitialValueToCompare(pd.qtdeSugerida)"
                                            type="number"
                                            :min="0"
                                            :maxlength="10"
                                            :disabled="isSaving"
                                        />
                                    </p>
                                    <p class="answer">
                                        {{ pd.datahora | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        <span
                                            v-if="verifyLocationIsValid(pd.lat, pd.lng)"
                                            @click="openLocation(pd.lat, pd.lng)"
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <div class="option">
                                        <div
                                            class="opt-img-block"
                                            v-for="(ft, i) in pd.fotos"
                                            :key="i"
                                        >
                                            <div>
                                                <div class="opt-img">
                                                    <img 
                                                        class="is-clickable"
                                                        :src="ft.caminho"
                                                        :alt="ft.nome"
                                                        @click="showModalFotos(pd.fotos, i)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            {{ $t('ruptura') }} <br />
                                                            {{
                                                                ft.datahora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p>{{ ft.obs }}</p>
                                                    </div>
                                                    <div class="icon-location">
                                                        <b-checkbox
                                                            v-model="ft.exportaRelatorio"
                                                            @input="(event) => changeImageVisibilityInReport(event, ft, 'ruptura')"
                                                            class="is-larger"
                                                            type="is-primary"
                                                        />
                                                        <span
                                                            v-if="
                                                                verifyLocationIsValid(
                                                                    pd.lat,
                                                                    pd.lng
                                                                )
                                                            "
                                                            @click="openLocation(pd.lat, pd.lng)"
                                                        >
                                                            <b-icon
                                                                class="map-marker"
                                                                pack="fas"
                                                                icon="map-marker-alt"
                                                                type="is-primary"
                                                            />
                                                        </span>
                                                        <b-icon
                                                            v-else
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-gray"
                                                        />
                                                        <div @click="openEditFotoModal(ft, 'ruptura')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="pencil"
                                                                type="is-primary"
                                                            />
                                                        </div>
                                                        <div @click="showConfirmModal('deseja-excluir-foto-atendimento', ft, 'ruptura')">
                                                        <b-icon
                                                                class="map-marker"
                                                                icon="delete"
                                                                type="is-danger"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-client" v-if="data.pesquisas && data.pesquisas.length > 0">
                            <div class="separator">
                                {{ $t('pesquisa') + pesquisaComplement }}
                            </div>
                            <div class="data-block-img pesquisa">
                                <div class="client-info">
                                    <h4 class="label bigger">{{ $t('produto') }}</h4>
                                    <h4 class="label">{{ $t('valor') }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                    <h4 class="label">{{ $t('gps') }}</h4>
                                </div>
                                <div class="client-info" v-for="(pd, i) in data.pesquisas" :key="i">
                                    <p class="answer bigger">{{ pd.produto }}</p>
                                    <p class="answer">{{ pd.valor }}</p>
                                    <p class="answer">
                                        {{ pd.datahora | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        <span
                                            v-if="verifyLocationIsValid(pd.lat, pd.lng)"
                                            @click="openLocation(pd.lat, pd.lng)"
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <div class="option">
                                        <div
                                            class="opt-img-block"
                                            v-for="(ft, i) in pd.fotos"
                                            :key="i"
                                        >
                                            <div>
                                                <div class="opt-img">
                                                    <img 
                                                        class="is-clickable"
                                                        :src="ft.caminho"
                                                        :alt="ft.nome"
                                                        @click="showModalFotos(pd.fotos, i)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            {{ $t('pesquisa') }} <br />
                                                            {{
                                                                ft.datahora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p>{{ ft.obs }}</p>
                                                    </div>
                                                    <div class="icon-location">
                                                        <b-checkbox
                                                            v-model="ft.exportaRelatorio"
                                                            @input="(event) => changeImageVisibilityInReport(event, ft, 'pesquisa')"
                                                            class="is-larger"
                                                            type="is-primary"
                                                        />
                                                        <span
                                                            v-if="
                                                                verifyLocationIsValid(
                                                                    pd.lat,
                                                                    pd.lng
                                                                )
                                                            "
                                                            @click="openLocation(pd.lat, pd.lng)"
                                                        >
                                                            <b-icon
                                                                class="map-marker"
                                                                pack="fas"
                                                                icon="map-marker-alt"
                                                                type="is-primary"
                                                            />
                                                        </span>
                                                        <b-icon
                                                            v-else
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-gray"
                                                        />
                                                        <div @click="openEditFotoModal(ft, 'pesquisa')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="pencil"
                                                                type="is-primary"
                                                            />
                                                        </div>
                                                        <div @click="showConfirmModal('deseja-excluir-foto-atendimento', ft, 'pesquisa')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="delete"
                                                                type="is-danger"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-client" v-if="data.shares && data.shares.length > 0">
                            <div class="separator">
                                {{ $t('share') + ' (' + numShares + ')' }}
                            </div>
                            <div class="data-block-img share">
                                <div class="client-info">
                                    <h4 class="label bigger">{{ $t('modulo') }}</h4>
                                    <h4 class="label">{{ $t('valor') }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                    <h4 class="label">{{ $t('gps') }}</h4>
                                </div>
                                <div class="client-info" v-for="(pd, i) in data.shares" :key="i">
                                    <p class="answer bigger">{{ pd.tipomodulo }}</p>
                                    <p class="answer">{{ pd.qtde }}</p>
                                    <p class="answer">
                                        {{ pd.datahora | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        <span
                                            v-if="verifyLocationIsValid(pd.lat, pd.lng)"
                                            @click="openLocation(pd.lat, pd.lng)"
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <div class="option">
                                        <div
                                            class="opt-img-block"
                                            v-for="(ft, i) in pd.fotos"
                                            :key="i"
                                        >
                                            <div>
                                                <div class="opt-img">
                                                    <img 
                                                        class="is-clickable"
                                                        :src="ft.caminho"
                                                        :alt="ft.nome"
                                                        @click="showModalFotos(pd.fotos, i)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            {{ $t('share') }} <br />
                                                            {{
                                                                ft.datahora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p>{{ ft.obs }}</p>
                                                    </div>
                                                    <div class="icon-location">
                                                        <b-checkbox
                                                            v-model="ft.exportaRelatorio"
                                                            @input="(event) => changeImageVisibilityInReport(event, ft, 'share')"
                                                            class="is-larger"
                                                            type="is-primary"
                                                        />
                                                        <span
                                                            v-if="
                                                                verifyLocationIsValid(
                                                                    pd.lat,
                                                                    pd.lng
                                                                )
                                                            "
                                                            @click="openLocation(pd.lat, pd.lng)"
                                                        >
                                                            <b-icon
                                                                class="map-marker"
                                                                pack="fas"
                                                                icon="map-marker-alt"
                                                                type="is-primary"
                                                            />
                                                        </span>
                                                        <b-icon
                                                            v-else
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-gray"
                                                        />
                                                        <div @click="openEditFotoModal(ft, 'share')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="pencil"
                                                                type="is-primary"
                                                            />
                                                        </div>
                                                        <div @click="showConfirmModal('deseja-excluir-foto-atendimento', ft, 'share')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="delete"
                                                                type="is-danger"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="form-client"
                            v-if="data.vencimento && data.vencimento.length > 0"
                        >
                            <div class="separator">
                                {{ $t('vencimento') + vencimentoComplement }}
                            </div>
                            <div class="data-block-img">
                                <div class="client-info">
                                    <h4 class="label bigger">{{ $t('produto') }}</h4>
                                    <h4 class="label">{{ $t('quantidade') }}</h4>
                                    <h4 class="label">{{ $t('validade') }}</h4>
                                    <h4 class="label">{{ $t('lote') }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                    <h4 class="label">{{ $t('gps') }}</h4>
                                </div>
                                <div
                                    class="client-info"
                                    v-for="(pd, i) in data.vencimento"
                                    :key="i"
                                >
                                    <p class="answer bigger">{{ pd.produto ? pd.produto : "--" }}</p>
                                    <p class="answer">{{ pd.qtdevencido || pd.qtdevencido >= 0 ? pd.qtdevencido : "--" }}</p>
                                    <p v-if="pd.datavalidade" class="answer">
                                        {{ pd.datavalidade | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p v-else class="answer">{{ "--" }}</p>
                                    <p class="answer">{{ pd.lote ? pd.lote : "--" }}</p>
                                    <p class="answer">
                                        {{ pd.datahora | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        <span
                                            v-if="verifyLocationIsValid(pd.lat, pd.lng)"
                                            @click="openLocation(pd.lat, pd.lng)"
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <div class="option">
                                        <div
                                            class="opt-img-block"
                                            v-for="(ft, i) in pd.fotos"
                                            :key="i"
                                        >
                                            <div>
                                                <div class="opt-img">
                                                    <img 
                                                        class="is-clickable"
                                                        :src="ft.caminho"
                                                        :alt="ft.nome"
                                                        @click="showModalFotos(pd.fotos, i)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            {{ $t('vencimento') }} <br />
                                                            {{
                                                                ft.datahora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p>{{ ft.obs }}</p>
                                                    </div>
                                                    <div class="icon-location">
                                                        <b-checkbox
                                                            v-model="ft.exportaRelatorio"
                                                            @input="(event) => changeImageVisibilityInReport(event, ft, 'vencimento')"
                                                            class="is-larger"
                                                            type="is-primary"
                                                        />
                                                        <span
                                                            v-if="
                                                                verifyLocationIsValid(
                                                                    pd.lat,
                                                                    pd.lng
                                                                )
                                                            "
                                                            @click="openLocation(pd.lat, pd.lng)"
                                                        >
                                                            <b-icon
                                                                class="map-marker"
                                                                pack="fas"
                                                                icon="map-marker-alt"
                                                                type="is-primary"
                                                            />
                                                        </span>
                                                        <b-icon
                                                            v-else
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-gray"
                                                        />
                                                        <div @click="openEditFotoModal(ft, 'vencimento')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="pencil"
                                                                type="is-primary"
                                                            />
                                                        </div>
                                                        <div @click="showConfirmModal('deseja-excluir-foto-atendimento', ft, 'vencimento')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="delete"
                                                                type="is-danger"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="form-client"
                            v-if="data.reposicaoList && data.reposicaoList.length > 0"
                        >
                            <div class="separator">
                                {{ $t('reposicao') + reposicaoComplement }}
                            </div>
                            <div class="data-block-img">
                                <div class="client-info">
                                    <h4 class="label bigger">{{ $t('produto') }}</h4>
                                    <h4 class="label">{{ $t('quantidade') }}</h4>
                                    <h4 class="label">{{ $t('validade') }}</h4>
                                    <h4 class="label">{{ $t('lote') }}</h4>
                                    <h4 class="label">{{ $t('data-hora') }}</h4>
                                    <h4 class="label">{{ $t('gps') }}</h4>
                                </div>
                                <div
                                    class="client-info"
                                    v-for="(reposicao, index) in data.reposicaoList"
                                    :key="index"
                                >
                                    <p class="answer bigger">{{ reposicao.descricao_produto ? reposicao.descricao_produto : "--" }}</p>
                                    <p class="answer">{{ reposicao.qtde_reposicao || reposicao.qtde_reposicao >= 0 ? reposicao.qtde_reposicao : "--" }}</p>
                                    <p v-if="reposicao.data_validade" class="answer">
                                        {{ reposicao.data_validade | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p v-else class="answer">{{ "--" }}</p>
                                    <p class="answer">{{ reposicao.lote ? reposicao.lote : "--" }}</p>
                                    <p class="answer">
                                        {{ reposicao.dataHora | moment('DD/MM/YYYY HH:mm:ss') }}
                                    </p>
                                    <p class="answer">
                                        <span
                                            v-if="verifyLocationIsValid(reposicao.latitude, reposicao.longitude)"
                                            @click="openLocation(reposicao.latitude, reposicao.longitude)"
                                        >
                                            <b-icon
                                                class="map-marker"
                                                pack="fas"
                                                icon="map-marker-alt"
                                                type="is-primary"
                                            />
                                        </span>
                                        <b-icon
                                            v-else
                                            pack="fas"
                                            icon="map-marker-alt"
                                            type="is-gray"
                                        />
                                    </p>
                                    <div class="option">
                                        <div
                                            class="opt-img-block"
                                            v-for="(foto, index) in reposicao.reposicaoFotoList"
                                            :key="index"
                                        >
                                            <div>
                                                <div class="opt-img">
                                                    <img 
                                                        class="is-clickable"
                                                        :src="foto.caminho"
                                                        :alt="foto.nome"
                                                        @click="showModalFotos(reposicao.reposicaoFotoList, index)"
                                                    />
                                                </div>
                                                <div class="opt-legend">
                                                    <div class="opt-text">
                                                        <p>
                                                            {{ $t('reposicao') }} <br />
                                                            {{
                                                                foto.dataHora
                                                                    | moment('DD/MM/YYYY HH:mm:ss')
                                                            }}
                                                        </p>
                                                        <p>{{ foto.observacao }}</p>
                                                    </div>
                                                    <div class="icon-location">
                                                        <b-checkbox
                                                            v-model="foto.exportaRelatorio"
                                                            @input="(event) => changeImageVisibilityInReport(event, foto, 'reposicao')"
                                                            class="is-larger"
                                                            type="is-primary"
                                                        />
                                                        <span
                                                            v-if="
                                                                verifyLocationIsValid(
                                                                    reposicao.latitude,
                                                                    reposicao.longitude
                                                                )
                                                            "
                                                            @click="openLocation(reposicao.latitude, reposicao.longitude)"
                                                        >
                                                            <b-icon
                                                                class="map-marker"
                                                                pack="fas"
                                                                icon="map-marker-alt"
                                                                type="is-primary"
                                                            />
                                                        </span>
                                                        <b-icon
                                                            v-else
                                                            pack="fas"
                                                            icon="map-marker-alt"
                                                            type="is-gray"
                                                        />
                                                        <div @click="openEditFotoModal(foto, 'reposicao')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="pencil"
                                                                type="is-primary"
                                                            />
                                                        </div>
                                                        <div @click="showConfirmModal('deseja-excluir-foto-atendimento', foto, 'reposicao')">
                                                            <b-icon
                                                                class="map-marker"
                                                                icon="delete"
                                                                type="is-danger"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="form-client"
                            v-for="(form, i) in data.formularios"
                            :key="i"
                        >
                            <div class="separator">
                                {{ $t('formulario') + ` (${form.idform_formularioerp}) - ${form.titulo}` }}
                            </div>
                            <div class="data-block-form">
                                <div 
                                    class="client-info is-flex-column pt-4 pb-4"
                                    v-for="(grupoPergunta, i) in form.formGrupoPerguntaList" 
                                    :key="i"
                                >
                                    <span class="bold label f-18">{{ $t("grupo-pergunta") + `: ${grupoPergunta.descricao}` }}</span>
                                    <ol class="ml-8">
                                        <li 
                                            class="pt-2 pb-2"
                                            v-for="(pergunta, i) in grupoPergunta.formPerguntaList"
                                            :key="i"
                                        >
                                            <span class="is-flex is-flex-vcenter">
                                                <span
                                                    class="mr-1"
                                                    v-tippy 
                                                    :title="$t(tipos[pergunta.item_tipo].label)"
                                                >
                                                    <svg class="svg-icons">
                                                        <use
                                                            :xlink:href="
                                                                require('@/assets/img/icons/' + tipos[pergunta.item_tipo].svg + '.svg') +
                                                                '#layer'
                                                            "
                                                        ></use>
                                                    </svg>
                                                </span>
                                                <span class="bold">{{ pergunta.descricao }}</span>
                                            </span>
                                            <ul>
                                                <li
                                                    v-for="(respostaPreenchida, i) in pergunta.formRespostaPreenchidaList"
                                                    :key="i"
                                                >
                                                    <span v-if="pergunta.item_tipo === 'DECIMAL'">R$ {{ getDecimal(respostaPreenchida.resposta) }}</span>
                                                    <span v-else-if="pergunta.item_tipo === 'PERCENT'">{{ parseAsPercent(respostaPreenchida.resposta) }}</span>
                                                    <span v-else>{{ respostaPreenchida.resposta ? respostaPreenchida.resposta : $t('nao-respondido') }}</span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            <div class="separator">
                                {{ $t('formulario') + ` - Assinatura` }}
                            </div>
                        </div>


                        <div class="assinatura" v-if="data.assinatura">
                            <div class="opt-img">
                                <img :src="data.assinatura.caminho" alt />
                            </div>
                            <div class="opt-legend">
                                {{ data.assinatura.nome }}
                            </div>
                            <div class="opt-obs">
                                {{ data.assinatura.observacao }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MapasGoogleMapsModal
            :center="center"
            :locationEditorOpen="locationOpen"
            :update="false"
            :showSaveButton="false"
            @onCancelLocationEditor="onCancelLocation"
        />
        <lateral-content
            v-model="showModalFormulario"
            :title="$t('formulario')"
            header
            @input="idformulario = null"
        >
            <AtendimentoFormularioView
                v-if="idformulario != null"
                ref="FormularioView"
                :idformulario="idformulario"
                :idatendimento="+$route.params.idatendimento"
            />
        </lateral-content>

        <b-modal
            class="modal-default"
            :active.sync="isShowModalEditFoto"
            style="z-index: 1000"
            @close="closeModalEditFoto"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="custom-header">
                        <h1 class="title">{{ $t("substituir-imagem") }}</h1>

                        <button
                            class="save-btn btn-size"
                            type="button"
                            tag="button"
                            @click="showConfirmModal('confirmacao-substituir-imagem')"
                            :disabled="!imgPlaceholder || isLoading"
                        >
                            {{ $t("salvar") }}
                        </button>
                    </div>
                    <div class="title-breadcrumb">
                        <div class="img-picker">
                            <ImgPicker
                                ref="imgPicker"
                                :logourl="imgPlaceholder"
                                @uploadedFiles="getImage"
                                @alert="showMessageImg"
                                :title="''"
                                :customMaxImageWidth="2000"
                                :customMinImageWidth="250"
                                :customMaxImageHeight="2000"
                                :customMinImageHeight="250"
                                :customMaxFileSizeMb="2"
                                :dataImage="dataImage"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal
            class="modal-default"
            :active.sync="isShowModalFotos"
            style="z-index: 1000"
            @close="closeModalFotos"
        >
            <div class="modal-card-body">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <template>
                            <b-carousel
                                v-model="currentIndexFoto"
                                :pause-info="false"
                                :animated="'fade'"
                                :progress="true"
                            >
                                <b-carousel-item v-for="(foto, i) in fotosToDisplay" :key="i">
                                    <section :class="'hero is-medium'">
                                        <div class="hero-body-img has-text-centered custom-size">
                                            <img 
                                                class="img-size"
                                                :src="foto.caminho"
                                                :alt="foto.nome"
                                                loading="lazy"
                                            >
                                        </div>
                                    </section>
                                </b-carousel-item>
                            </b-carousel>
                        </template>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ProAtendimentoService from '@/services/promotor/ProAtendimentoService.js';
import MapasGoogleMapsModal from '@/components/shared/maps/MapasGoogleMapsModal.vue';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';
import AtendimentoFormularioView from '@/components/promotor/relatorio/atendimento/AtendimentoFormularioView.vue';
import ImgPicker from "@/components/shared/form/ImgPicker";
import Content from '@/buefy/Content.vue';

export default {
    name: 'DetalhesAtendimento',
    components: {
        MapasGoogleMapsModal,
        ContainerLoader,
        AtendimentoFormularioView,
        ImgPicker,
    },
    data() {
        return {
            isShowModalFotos: false,
            isShowModalEditFoto: false,
            showModalFormulario: false,
            idformulario: null,
            mapimg: '',
            data: {},
            numFormularios: 0,
            numFotos: 0,
            numShares: 0,
            rupturaComplement: '',
            vencimentoComplement: '',
            reposicaoComplement: '',
            pesquisaComplement: '',
            center: {
                lat: null,
                lng: null,
            },
            locationOpen: false,
            service: new ProAtendimentoService(this.$http, this.$router),
            isLoading: false,
            isSaving: false,
            imgPlaceholder: null,
            fotosToDisplay: [],
            currentIndexFoto: 0,
            currentFoto: null,
            currentContext: null,
            tipos: {
                'TEXT': {
                    svg: 'text-short',
                    label: 'area-texto-curto',
                },
                'MULTITEXT': {
                    svg: 'text-subject',
                    label: 'area-texto-longo',
                },
                'INTEGER': {
                    svg: 'text-short',
                    label: 'campo-numero',
                },
                'DECIMAL': {
                    svg: 'currency-usd',
                    label: 'campo-moeda',
                },
                'PERCENT': {
                    svg: 'percent',
                    label: 'campo-porcentagem',    
                },
                'SWITCH': {
                    svg: 'text-short',
                    label: 'disjuntor',
                },
                'DATETIME': {
                    svg: 'calendar-clock',
                    label: 'campo-data-hora',
                },
                'DATE': {
                    svg: 'calendar',
                    label: 'calendario',
                },
                'RADIO': {
                    svg: 'radiobox-marked',
                    label: 'multipla-escolha',
                },
                'CHECKBOX': {
                    svg: 'checkbox-marked',
                    label: 'lista-opcoes',
                },
                'COMBOBOX': {
                    svg: 'menu-down',
                    label: 'combo-box',
                },
            },
            dataImage: {
                'largura': '2000',
                'altura': '2000',
                'size': '2MB'
            },
            justificativa: null,
            fotoJustificativa: {
                caminho: null,
                nomeDocumento: null,
                datahora: null
            },
            fotosJustificativa: [],
            habilita_troca: false,
            habilita_area_venda: false,
            habilita_deposito: false,
            habilita_houve_ruptura: false,
            habilita_obriga_qtde_sugerida: false,
            initialValueQtdeSugerida: 0,
            idAtendimento: null,
        };
    },
    created() {
        this.carregarDados();
    },
    methods: {
        changeImageVisibilityInReport(isVisibleInReport, foto, context) {
            this.loading = true;

            const id = foto.idatendimentofoto || foto.idpro_atendimento_reposicao_foto;

            const partialFoto = {
                id,
                exportaRelatorio: isVisibleInReport
            };
            
            this.$axios.post(`/report-promotor/services/photo/${context}/visibility`, partialFoto)
            .then((_) => {})
            .catch((e) => {
                this.$root.showMessage("error", "erro-alterar-imagem", true);
                console.log(e);
            })
            .finally((_) => {
                this.loading = false;
            })
        },
        saveInitialValueToCompare(qtdeSugerida) {
            this.initialValueQtdeSugerida = qtdeSugerida;
        },
        isQtdeSugeridaInvalid(qtdeSugerida) {
            const obrigaQtdeSugerida = this.habilita_obriga_qtde_sugerida === 2;

            if (obrigaQtdeSugerida) return !Boolean(qtdeSugerida);
        },
        saveQtdeSugerida(idElementToUpdate, qtdeSugerida) {
            const valueIsNotBeingChanged = qtdeSugerida === this.initialValueQtdeSugerida;

            if(this.isQtdeSugeridaInvalid(qtdeSugerida) || valueIsNotBeingChanged) return;

            this.isSaving = true;
            
            this.$axios
                .patch('/report-promotor/services/detailed/ruptura/qtde-sugerida', {
                    idatendimentoruptura: idElementToUpdate,
                    qtdeSugerida
                })
                .then((_) => {})
                .catch((e) => {
                    console.log(e)
                    this.$root.showMessage("error", "erro-alterar-quantidade-sugerida", true);
                })
                .finally((_) => this.isSaving = false);
        },
        showModalFotos(fotos, index) {
            this.currentIndexFoto = index;
            this.fotosToDisplay = fotos;
            this.isShowModalFotos = true;
        },
        saveNewFoto() {
            this.isLoading = true;
            
            const { mediaFile, ...rest } = this.currentFoto;

            const mappedFoto = this.getFoto(rest);

            this.service
                .save(mediaFile, this.currentContext, mappedFoto)
                .then((_) => {
                    this.carregarDados();

                    this.closeModalEditFoto();

                    const msg = this.$t("imagem-alterada-sucesso");
                    
                    this.$root.showMessage("success", msg, true, false);
                })
                .catch((_) => {
                    this.$root.showMessage("error", "erro-alterar-imagem", true);
                })
                .finally((_) => {
                    this.isLoading = false;
                })
        },
        getFoto(obj) {
            const contextMapping = {
                reposicao: {
                    id: obj.idpro_atendimento_reposicao_foto,
                    nome: obj.nome_documento
                },
                default: {
                    id: obj.idatendimentofoto,
                    nome: obj.nomeDocumento
                }
            };

            const contextKey = this.currentContext;
            const defaultContext = contextMapping.default; 

            return contextMapping[contextKey] || defaultContext;
        },
        showConfirmModal(message, foto, context) {
            if(context) this.currentContext = context;

            this.$root.confirm({
                message: this.$t(message),
                onConfirm: (_) => foto ? this.removeFotoRelatorio(foto) : this.saveNewFoto(),
                onCancel: (_) => this.currentContext = null,
            });
        },
        getImage(imagens) {
            if (imagens.length > 0) {
                const { imgurl, file } = imagens[0];
                
                this.imgPlaceholder = imgurl;
                
                this.currentFoto.mediaFile = file;
            }
        },
        showMessageImg(type, msg) {
            this.$root.showMessage(type, msg);
        },
        removeFotoRelatorio(foto) {
            this.isLoading = true;

            const mappedFoto = this.getFoto(foto);

            this.service
                .removeFoto(mappedFoto, this.currentContext)
                .then((_) => {
                    this.carregarDados();

                    const msg = this.$t("imagem-removida-sucesso");

                    this.$root.showMessage("success", msg, true, false);
                })
                .catch((_) => {
                    this.$root.showMessage("error", "erro-remover-imagem", true);
                })
                .finally((_) => {
                    this.isLoading = false;
                })
        },
        voltar() {
            if (this.$route.name == 'promotor-atendimento-view') {
                this.$router.push({ name: 'promotor-atendimento-list' });
            } else if (this.$route.name == 'promotor-atendimento-lps-view') {
                this.$router.push({ name: 'promotor-atendimento-lps-list' });
            } else if (this.$route.name == 'promotor-atendimento-contrato-view') {
                this.$router.push({ name: 'promotor-atendimento-contrato-list' });
            }
        },
        closeModalFotos(){
            this.isShowModalFotos = false;
        },
        closeModalEditFoto() {            
            this.imgPlaceholder = null;
            this.currentFoto = null;
            this.currentContext = null;

            this.isShowModalEditFoto = false;
        },
        openEditFotoModal(foto, context) {
            this.currentFoto = foto;
            this.currentContext = context;

            this.isShowModalEditFoto = true;
        },
        totalTime(times) {
            let duration = times.reduce(
                (acc, time) => acc.add(this.$moment.duration(time.tempo_atendimento)),
                this.$moment.duration()
            );
            return this.$moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
        },
        verifyLocationIsValid(lat, lng) {
            let validLatitude = lat >= -90 && lat <= 90 && lat != 0.0;
            let validLongitude = lng >= -180 && lng <= 180 && lng != 0.0;
            return validLatitude && validLongitude;
        },
        openLocation(lat, lng) {
            this.center.lat = +lat;
            this.center.lng = +lng;
            this.locationOpen = true;
        },
        onCancelLocation() {
            this.locationOpen = false;
            this.center.lat = 0;
            this.center.lng = 0;
        },
        carregarFotos() {
            this.isLoading = true;
            const idAtendimento = this.$route.params.idatendimento;

            // Certifique-se de usar 'arraybuffer' para dados binários
            this.$axios
                .get(`/report-promotor/services/exportacao/zip/${idAtendimento}`, { responseType: 'arraybuffer' })
                .then((response) => {
                    const binaryData = response.data;  // Recebe dados binários corretamente
                    this.downloadZip(binaryData);      // Chama o método de download
                })
                .catch(error => {
                    console.error("Erro ao buscar imagens", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        downloadZip(binaryData) {
            // Certifique-se de usar os dados binários diretamente no Blob
            const blob = new Blob([binaryData], { type: 'application/zip' }); // Tipo correto para arquivos ZIP
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'imagens.zip'); // Nome do arquivo a ser baixado
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Limpa a URL temporária após o download
        },

        carregarDados() {
            this.isLoading = true;
            
            const idAtendimento = this.$route.params.idatendimento;

            this.$axios
                .get(`/report-promotor/services/detailed/${idAtendimento}`)
                .then((res) => {
                    const content = res.data.content;
                    this.data = content;

                    console.log("[DADO VENCIMENTO]: \n", this.data.vencimento);

                    this.numFormularios = content.formularios.length;
                    this.numFotos = content.fotos.length;
                    this.numShares = content.shares.length;

                    if(content.justificativa) {
                        this.justificativa = content.justificativa
                    }

                    if (content.fotoJustificativa) {
                        this.fotosJustificativa = content.fotoJustificativa;
                    }

                    if (content.rupturas && content.rupturas.length > 0) {
                        this.rupturaComplement =
                            ' (' +
                            content.rupturas.length +
                            ' ' +
                            this.$t('de') +
                            ' ' +
                            (content.rupturas[0].total > content.rupturas.length
                                ? content.rupturas[0].total
                                : content.rupturas.length) +
                            ' ' +
                            this.$t('produtos') +
                            ')';
                    }
                    if (content.vencimento && content.vencimento.length > 0) {
                        this.vencimentoComplement =
                            ' (' +
                            content.vencimento.length +
                            ' ' +
                            this.$t('de') +
                            ' ' +
                            (content.vencimento[0].total > content.vencimento.length
                                ? content.vencimento[0].total
                                : content.vencimento.length) +
                            ' ' +
                            this.$t('produtos') +
                            ')';
                    }
                    if (content.reposicaoList && content.reposicaoList.length > 0) {
                        this.reposicaoComplement = 
                        ' (' +
                            content.reposicaoList.length +
                            ' ' +
                            this.$t('de') +
                            ' ' +
                            (content.reposicaoList[0].total > content.reposicaoList.length
                                ? content.reposicaoList[0].total
                                : content.reposicaoList.length) +
                            ' ' +
                            this.$t('produtos') +
                            ')';
                    }
                    if (content.pesquisas && content.pesquisas.length > 0) {
                        this.pesquisaComplement =
                            ' (' +
                            content.pesquisas.length +
                            ' ' +
                            this.$t('de') +
                            ' ' +
                            (content.pesquisas[0].total > content.pesquisas.length
                                ? content.pesquisas[0].total
                                : content.pesquisas.length) +
                            ' ' +
                            this.$t('produtos') +
                            ')';
                    }
                    if (content.tiposervico) {
                        const {
                            habilita_obriga_troca,
                            habilita_obriga_area_venda,
                            habilita_obriga_deposito,
                            habilita_obriga_houve_ruptura,
                            habilita_obriga_qtde_sugerida
                        } = content.tiposervico;

                        this.habilita_troca = habilita_obriga_troca;
                        this.habilita_area_venda = habilita_obriga_area_venda;
                        this.habilita_deposito = habilita_obriga_deposito;
                        this.habilita_houve_ruptura = habilita_obriga_houve_ruptura;
                        this.habilita_obriga_qtde_sugerida = habilita_obriga_qtde_sugerida;
                    }
                    
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        getMapImgUrl(lat, lng) {
            this.mapimg =
                'https://maps.googleapis.com/maps/api/staticmap?markers=color:purple%7C' +
                lat +
                ',' +
                lng +
                '&zoom=14&size=640x200&scale=1&key=AIzaSyCJCQZ3vFYpmnlm1bCpTHZiuz5g3PqDg4w';
        },
    },
};
</script>
<style lang="scss" scoped>
.is-larger {
    transform: scale(1.2)
}

.img-picker {
    max-height: 85vh;
}

.f-18 {
    font-size: 18px;
}

.ml-8 {
    margin-left: 80px;
}

.img-size {
    max-height: 90vh;
}

.custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
}

.btn-size {
    padding: 16px 32px;
}

.custom-size {
    max-width: 1000px;
    max-height: 90vh;
}

.custom-size > img {
    width: min-content;
}

#main3 {
    padding: 0 20px;
    height: 100%;

    .map-marker:hover {
        cursor: pointer;
        opacity: 0.5;
    }

    .smaller {
        width: 10% !important;
    }

    .header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        height: auto;

        .enterprise-logo,
        .client-logo {
            width: 15%;
            text-align: center;
            object-fit: cover;
            align-items: center;
            display: flex;
            justify-content: center;

            .logo {
                height: auto;
                max-height: 80px;
            }
        }
        .enterprise-info {
            width: 65%;
            text-align: center;
            margin-bottom: 20px;

            h2 {
                text-align: center;
                font-size: 18px;
                font-weight: 600;
            }
            p {
                font-size: 12px;
                margin-bottom: 5px;
            }
        }
        .report-title {
            font-size: 20px;
            margin-bottom: 10px;

            h1 {
                font-weight: 600;
            }
        }
    }

    .form {
        width: 100%;

        .form-client {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-bottom: 20px;

            .separator {
                width: 100%;
                border-top: 1px solid $table-border;
                border-bottom: 1px solid $table-border;
                padding: 10px 0;
                text-align: center;
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 18px;
            }

            .data-block {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .client-info .label {
                    font-weight: 600;
                    margin-right: 5px;
                }

                .client-info {
                    width: 50%;
                    margin-bottom: 5px;
                    font-size: 14px;

                    display: flex;
                    justify-content: flex-start;
                }
            }

            .data-block-alt {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .client-info {
                    width: 20%;
                }
            }

            .data-block-form {
                width: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                .client-info {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;

                    h4,
                    p {
                        width: 20%;
                        padding: 3px;
                    }
                }
            }

            .data-block-img {
                width: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .client-info {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    margin-bottom: 10px;

                    h4,
                    p {
                        font-size: 14px;
                        width: 10%;
                        &.bigger {
                            width: 40%;
                        }
                        &.mid-size {
                            width: 160px;
                        }
                    }
                }
                .option {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 5px;
                    flex-wrap: wrap;

                    .opt-img-block {
                        margin-right: 20px;
                        padding: 10px;

                        .opt-teste {
                            width: 300px;
                            height: 175px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }

                        .opt-img {
                            width: 300px;
                            height: 250px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                        .opt-legend,
                        .opt-obs {
                            font-size: 12px;
                            display: flex;
                            justify-content: space-between;
                            margin-top: 5px;
                            word-wrap: break-word;

                            p {
                                width: 75%;
                                text-transform: uppercase;
                            }
                            .icon-location {
                                display: flex;
                                align-items: center;
                                justify-content: space-evenly;
                                gap: 4px;
                                text-align: right;
                                .svg-icons {
                                    width: 30px;
                                    height: 30px;
                                }
                            }

                            .opt-text {
                                display: flex;
                                flex-wrap: wrap;
                                p {
                                    width: 97%;
                                }
                                .opt-text-observacao {
                                    border-top: dashed 1px #e4e4e4;
                                    max-width: 100%;
                                    word-break: break-word;
                                    overflow-wrap: break-word;
                                }
                            }
                        }
                    }
                }

                &.share,
                &.pesquisa {
                    .client-info {
                        h4,
                        p {
                            width: 10%;
                            &.bigger {
                                width: 60%;
                            }
                            &.mid-size {
                                width: 160px;
                            }
                        }
                    }
                }
            }

            .map-photo {
                text-align: center;
                width: 100%;
                margin-top: 10px;

                img {
                    border: 1px solid $table-border;
                    max-width: 80%;
                }
            }
        }

        .assinatura {
            margin-top: 20px;
            margin-right: 20px;
            height: 300px;

            .opt-img {
                border-bottom: 1px solid $table-border;
                height: 250px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }

            .opt-legend,
            .opt-obs {
                font-size: 12px;
                display: flex;
                justify-content: space-between;
                margin-top: 5px;
                word-break: break-word;
                p {
                    width: 100%;
                }
            }
        }
    }

    .icon-button {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
    .icon-position {
        border: none;
        background-color: #fff;
        color: #0c0c0c;
        font-size: 16px;
        cursor: pointer;
        margin-left: 12px;
    }
}
</style>
